<template>
  <div id="app">
    <div class="header">
      <!-- <announcement></announcement> -->
      <zoon-header></zoon-header>
    </div>
    <div class="content">
      <router-view></router-view>
    </div>
    <bottom-bar class="bottom" v-show="screenWidth<960" :selected="selected" :tabBars="tabBars"></bottom-bar>
  </div>
</template>


<script>

import contractObject from '@/decentralizedApi/inits';
import {mapGetters} from 'vuex';

export default {
  data() {
    return {
      selected: 0,
      timer:null,
      tabBars: [
        {
          name: "/swap",
          isShowRedDot: false,
          badge: "",
          text: this.$t('message.mallHeader.Trade'),
          iconPath: require("./assets/bottombar/tabbar_trade.svg"),
          selectedIconPath: require("./assets/bottombar/tabbar_trade_2.svg"),
        },
        {
          name: "/liquidity",
          isShowRedDot: false,
          badge: "",
          text: this.$t('message.mallHeader.Earn'),
          iconPath: require("./assets/bottombar/tabbar_earn.svg"),
          selectedIconPath: require("./assets/bottombar/tabbar_earn_2.svg"),
        },
        {
          name: "/Explore",
          isShowRedDot: false,
          badge: "",
          text: this.$t('message.mallHeader.Explore'),
          iconPath: require("./assets/bottombar/tabbar_win.svg"),
          selectedIconPath: require("./assets/bottombar/tabbar_win_2.svg"),
        },
        // {
        //   name: "/meta",
        //   isShowRedDot: false,
        //   badge: "",
        //   text: this.$t('message.mallHeader.Meta'),
        //   iconPath: require("./assets/bottombar/tabbar_meta.svg"),
        //   selectedIconPath: require("./assets/bottombar/tabbar_meta_2.svg"),
        // },
        // {
        //   name: "/more",
        //   isShowRedDot: false,
        //   badge: "",
        //   text: "",
        //   iconPath: require("./assets/bottombar/tabbar_more.svg"),
        //   selectedIconPath: require("./assets/bottombar/tabbar_more_2.svg"),
        // },
      ],
    };
  },
  
  created() {
    this.isConnectWallet && this.addNetworkBlockNumber();
  },
  mounted() {
    this.$store.dispatch('wallet/setScreenWidth', document.body.clientWidth);
    window.onresize = () => {//这个方法会被调用两次,软键盘弹出后和软件收起后
      return (() => {
        this.$store.dispatch('wallet/setScreenWidth', document.body.clientWidth);
      })()
    }
  },
  computed: {
    ...mapGetters(['isConnectWallet', 'walletAddress', 'gasPrice', 'slippage', 'deadline', 'transactions', 'block', 'screenWidth'])
  },
  watch: {
    '$i18n.locale'(val, oval) {
      this.tabBars = [
        {
          name: "/swap",
          isShowRedDot: false,
          badge: "",
          text: this.$t('message.mallHeader.Trade'),
          iconPath: require("./assets/bottombar/tabbar_trade.svg"),
          selectedIconPath: require("./assets/bottombar/tabbar_trade_2.svg"),
        },
        {
          name: "/liquidity",
          isShowRedDot: false,
          badge: "",
          text: this.$t('message.mallHeader.Earn'),
          iconPath: require("./assets/bottombar/tabbar_earn.svg"),
          selectedIconPath: require("./assets/bottombar/tabbar_earn_2.svg"),
        },
        {
          name: "/Explore",
          isShowRedDot: false,
          badge: "",
          text: this.$t('message.mallHeader.Explore'),
          iconPath: require("./assets/bottombar/tabbar_win.svg"),
          selectedIconPath: require("./assets/bottombar/tabbar_win_2.svg"),
        },
        // {
        //   name: "/meta",
        //   isShowRedDot: false,
        //   badge: "",
        //   text: this.$t('message.mallHeader.Meta'),
        //   iconPath: require("./assets/bottombar/tabbar_meta.svg"),
        //   selectedIconPath: require("./assets/bottombar/tabbar_meta_2.svg"),
        // },
        // {
        //   name: "/more",
        //   isShowRedDot: false,
        //   badge: "",
        //   text: "",
        //   iconPath: require("./assets/bottombar/tabbar_more.svg"),
        //   selectedIconPath: require("./assets/bottombar/tabbar_more_2.svg"),
        // },
      ];
    },
    isConnectWallet(val, oval) {
      if (val) {
        this.addNetworkBlockNumber();
      }else {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      } 
    },
    block() {
      this.handleUpdateTransactions();
    },
  },
  methods: {
    async addNetworkBlockNumber() {
      const blockNumber = await contractObject.getWeb3ModalProvider(false).eth.getBlockNumber();
      await this.$store.dispatch('wallet/setBlock', blockNumber);
      this.timer = setInterval(async () => {
        const blockNumber = await contractObject.getWeb3ModalProvider(false).eth.getBlockNumber();
        await this.$store.dispatch('wallet/setBlock', blockNumber);
      }, 6000);
    },
    
    handleUpdateTransactions() {
      if (!this.walletAddress) return;
      const allTransactions = Object.values(this.transactions);
      const pendTransactions = allTransactions.filter(item => {
        return !item.receipt && item.from.toLowerCase() == this.walletAddress.toLowerCase();
      });

      pendTransactions.forEach((item, index) => {
        const provider = contractObject.getWeb3ModalProvider(false).eth;

        const getReceiptWithRetry = async (transationItem) =>{
          try {
            const receipt = await provider.getTransactionReceipt(transationItem.hash);
            if (receipt) {
              this.$store.dispatch('wallet/setTransactionsReceipt', {hash: transationItem.hash,receipt});
              if (document.documentElement.clientWidth < 400) {
                this.$message({ type: 'success', title: transationItem.title, message: transationItem.message, hash: receipt.hash });
              } else {
                this.$message({ position: 'top-right', type: 'success', title: transationItem.title, message: transationItem.message, hash: receipt.hash });
              }
            }
          } catch (error) {
            console.log('get transactionReceipt error =',error);
          }
        }
        getReceiptWithRetry(item);
      });
    },
  },
  beforeDestroy() {
    window.clearInterval(this.timer);
  },
  destroyed() {
    window.onresize = null
  }
}

</script>

<style lang="scss" scoped>
#app {
  display: flex;
  display: -webkit-flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  color: var(--white);
  /*定义滚动条高宽及背景
   高宽分别对应横竖滚动条的尺寸*/
  ::-webkit-scrollbar {
    width: 4px;
    height: 70px;
    background-color: #F5F5F5;
  }
  /*定义滚动条轨道
   内阴影+圆角*/
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }
  /*定义滑块
   内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: #555;
  }
  .header {
    flex: none;
  }
  .content {
    flex: 1 1 auto;
    max-height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: black;
  }
  .bottom {
    flex: none;
  }
}

</style>
